
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M12 2C6.48583 2 2 6.48583 2 12C2 17.5142 6.48583 22 12 22C17.5142 22 22 17.5142 22 12C22 6.48583 17.5142 2 12 2ZM12 20.3333C9.75583 20.3333 7.72 19.4375 6.22 17.9892C6.46833 16.3983 7.61667 15.7833 9.08333 15.295C10.0692 14.9667 10.495 14.0975 10.6825 13.3942C9.4975 12.8825 8.66667 11.7058 8.66667 10.3333V9.5C8.66667 7.65917 10.1592 6.16667 12 6.16667C13.8408 6.16667 15.3333 7.65917 15.3333 9.5V10.3333C15.3333 11.7058 14.5025 12.8825 13.3175 13.3942C13.5067 14.0992 13.935 14.9683 14.9167 15.295C16.385 15.7842 17.5342 16.38 17.7808 17.9892C16.2808 19.4375 14.2442 20.3333 12 20.3333Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowSsoFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
